import React from 'react';
import PropTypes from 'prop-types';
import { reducer } from './reducer';
import { BeaconInput } from './BeaconInput';

const defaultViewableImpressionBeacons = creative => {
  const viewableImpressionBeacons = ((creative && creative.beacons) || []).filter(
    beacon => beacon.event === 'visible'
  );

  return viewableImpressionBeacons.length === 0
    ? [{ event: 'visible', url: '' }]
    : viewableImpressionBeacons;
};

export const ViewableImpressionBeaconList = ({
  creative,
  CreativeService,
  beaconRequired
}) => {
  const [beacons, dispatch] = React.useReducer(
    reducer,
    defaultViewableImpressionBeacons(creative)
  );

  React.useEffect(
    function overwriteViewableImpressionBeacons() {
      const previousBeacons = creative.beacons || [];
      CreativeService.set('beacons', [
        ...previousBeacons.filter(({ event }) => event !== 'visible'),
        ...beacons
      ]);
    },
    [beacons]
  );

  React.useEffect(
    function updateRequiredFlags() {
      dispatch({ type: 'setRequired', payload: { required: beaconRequired } });
    },
    [beaconRequired]
  );

  const handleViewableImpressionUrlChange = (index, url) => {
    dispatch({ type: 'updateBeacon', index, payload: { url } });
  };

  const handleVendorChange = (index, vendorId) => {
    dispatch({ type: 'assignVendor', index, vendorId });
  };

  return beacons.map((beacon, index, impBeacons) => {
    const button =
      index === impBeacons.length - 1 ? (
        <button
          className="btn btn-default"
          type="button"
          onClick={() => dispatch({ type: 'addBeacon', event: 'visible' })}
        >
          + New Tag
        </button>
      ) : (
        <button
          className="btn btn-default"
          type="button"
          onClick={() => dispatch({ type: 'removeBeacon', index })}
        >
          Remove
        </button>
      );


    return (
      <BeaconInput
        key={`visible-beacon-${index}`}
        nameAttr={`visible_beacon_${index}`}
        value={beacon.url}
        applyGdprValidations={!!creative.runningInEu}
        labelContent="Viewable Impression Tracker (1x1)"
        onInputChange={event =>
          handleViewableImpressionUrlChange(index, event.target.value)
        }
        onVendorChange={vendorId => handleVendorChange(index, vendorId)}
        button={button}
      />
    );
  });
};

ViewableImpressionBeaconList.propTypes = {
  creative: PropTypes.shape({
    runningInEu: PropTypes.bool,
    action: PropTypes.string,
    beacons: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        event: PropTypes.string
      })
    )
  }).isRequired,
  CreativeService: PropTypes.shape({
    set: PropTypes.func.isRequired
  }).isRequired,
  beaconRequired: PropTypes.bool.isRequired
};
